module.exports = __webpack_public_path__ + "static/img/clients.fb93ca20.png";